module.exports = __webpack_public_path__ + "static/media/nysci.d07c3cdb.png";